import type { MockOrganizationRow } from "@/lib/api/types/enterprise";

export const MOCK_ORGANIZATIONS: MockOrganizationRow[] = [
  {
    id: "11111111-1111-1111-1111-111111111111",
    name: "Root tenant (Local Dev)",
    type: "Client",
    parent_id: null,
    parent_name: null,
    region: "IN-West",
  },
  {
    id: "55555555-5555-5555-5555-555555555501",
    name: "Distributor North",
    type: "Distributor",
    parent_id: "11111111-1111-1111-1111-111111111111",
    parent_name: "Root tenant (Local Dev)",
    region: "IN-North",
  },
  {
    id: "55555555-5555-5555-5555-555555555502",
    name: "Sub-client Alpha",
    type: "Client",
    parent_id: "55555555-5555-5555-5555-555555555501",
    parent_name: "Distributor North",
    region: "IN-North",
  },
  {
    id: "55555555-5555-5555-5555-555555555503",
    name: "OEM Partner EU",
    type: "Reseller",
    parent_id: "11111111-1111-1111-1111-111111111111",
    parent_name: "Root tenant (Local Dev)",
    region: "EU-Central",
  },
];
